import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import { Button } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap 5
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // DataTable Bootstrap 5 Styles
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // DataTable Bootstrap 5 Responsive
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from "xlsx"; // For exporting to Excel
import Header from "../Header";

const DisplayWorkedDoc = () => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const id = localStorage.getItem('userId');  

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://apiaksharaconnect.aksharafinalytics.in/UserFiles/${id}`
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
        
        setData(result.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && data.length > 0) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, // Reinitialize on data change
        paging: true, // Enable pagination
        pageLength: 10, // Default number of rows per page
        lengthMenu: [10, 25, 50, 100], // Options for rows per page
        columnDefs: [
          { targets: 0, responsivePriority: 1 }, // Always visible
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [data]);


  const handleMultipleDownloads = (filePaths) => {
    filePaths.forEach((filePath) => {
      // Create an anchor tag for each file and trigger a click to start downloading
      const link = document.createElement('a');
      link.href = filePath;
      link.download = filePath.split('/').pop(); // Set file name as the last part of the URL
      link.target = '_blank'; // Open in new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  // Export to Excel
  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export!");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "data");
    XLSX.writeFile(wb, "data_List.xlsx");
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <div className="container-fluid mt-4">
        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>Display Worked Doc</h4>
            <button className="btn btn-success" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            {/* Responsive Table */}
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped table-bordered display nowrap"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Remarks</th>
                    <th>Documents</th>
                    <th>Date/Time</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data.map((data, index) => {
                      // Split the file_path string into individual file paths and prepend the base URL
                      const filePaths = data.file_path.split(',').map(filePath => 
                        `https://apiaksharaconnect.aksharafinalytics.in/${filePath.trim()}`
                      );

                      return (
                        <tr key={data.id}>
                          <td>{index + 1}</td>
                          <td>{data.remarks || "N/A"}</td>
                          <td>
                            {filePaths.length > 0 ? (
                              <>
                                <Button variant="warning" className="ms-2 p-1 m-1" onClick={() => handleMultipleDownloads(filePaths)}>
                                  <FontAwesomeIcon icon={faDownload} /> Download All
                                </Button>                      
                              </>
                            ) : (
                              <span>No file available</span>
                            )}
                          </td>
                          <td>{data.upload_at || "N/A"}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayWorkedDoc;